import { Component, Input } from '@angular/core';
import { Platform, ModalController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CoOnlineResourcesWidgetModalComponent } from '../co-online-resources-widget-modal/co-online-resources-widget-modal';

/**
 * Generated class for the CoOnlineResourcesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-online-resources-widget',
  templateUrl: 'co-online-resources-widget.html'
})
export class CoOnlineResourcesWidgetComponent {
  @Input() data: any;
  @Input() clientKeyword: any;
  currentPlatform: string;
  currentAccordionIndex: number = -1;

  constructor(private platform: Platform, private inAppBrowser: InAppBrowser, private modalCtrl: ModalController) {
    if (this.platform.is('ios')) this.currentPlatform = "ios";
    else if (this.platform.is('android')) this.currentPlatform = "android";
  }

  ngOnInit() {
    if (this.data.sections.length <= 1) this.currentAccordionIndex = 0;

    this.data.sections.forEach(list => {
      list.items.map(item =>{
        item.main_text = decodeURIComponent(item.main_text);
      });
    });
  }

  openUrl(url) {
    if (this.platform.is('cordova')) {
      this.inAppBrowser.create(url, "_system");
    } else {
      window.open(`${url}`, '_blank');
    }
  }

  updateView(style, index, section) {
    switch (style) {
      case "0": {
        if (this.currentAccordionIndex === index) {
          this.currentAccordionIndex = -1;
        } else {
          this.currentAccordionIndex = index;
        }
        break;
      }
      case "1": {
        this.openModal(section);
        break;
      }
      case "2": {
        this.openModal(section);
        break;
      }
      case "3": {
        this.openModal(section);
        break;
      }
    }
  }

  openModal(section) {
    let modal = this.modalCtrl.create(CoOnlineResourcesWidgetModalComponent, {clientKeyword: this.clientKeyword, section: section, currentPlatform: this.currentPlatform});

    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/co-online-resources-widget/co-online-resources-widget.ts